import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Box, Button, Divider, Typography } from '@mui/material';
import React from 'react';
import { useAuth } from '../auth/AuthContext';

type ImpersonationAccountInfoProps = {
  onExit?: () => void;
};

/** Compact impersonation status for the header account drawer. */
export function ImpersonationAccountInfo({ onExit }: ImpersonationAccountInfoProps) {
  const { user, isImpersonating, stopImpersonating, stopImpersonatingPending } = useAuth();

  if (!isImpersonating) return null;

  const userTypeLabel =
    user?.userTypeName?.trim() || user?.userTypeCode?.trim() || null;

  return (
    <>
      <Box
        data-testid="impersonation-account-info"
        sx={{
          px: 2,
          py: 1.25,
          bgcolor: 'warning.light',
        }}
      >
        <Typography variant="caption" color="text.secondary" display="block">
          Impersonating
        </Typography>
        <Typography variant="body2" fontWeight={600} noWrap title={user?.email}>
          {user?.username ?? user?.email ?? 'another user'}
        </Typography>
        {userTypeLabel ? (
          <Typography variant="caption" color="text.secondary" noWrap title={userTypeLabel}>
            {userTypeLabel}
          </Typography>
        ) : null}
        <Button
          color="warning"
          size="small"
          startIcon={<ExitToAppIcon />}
          onClick={() => {
            onExit?.();
            void stopImpersonating();
          }}
          disabled={stopImpersonatingPending}
          data-testid="impersonation-exit"
          sx={{ mt: 0.5, px: 0, minWidth: 0 }}
        >
          Exit impersonation
        </Button>
      </Box>
      <Divider />
    </>
  );
}
